import { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { needsSetup, subscribeBusinessConfig, configVersion } from '../utils/businessConfig';
import Sidebar from './Sidebar';
import MobileBottomNav from './MobileBottomNav';
import QuickActionFAB from './QuickActionFAB';
// UI_CONSOLIDATION 4B/4C — the approvals bell + the Ctrl-K palette. They live
// ABOVE every screen, which is why the portal grew a top bar to hold them.
import TopBar from './nav/TopBar';

const BaseLayout = ({ Content }) => {
  const { user, logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  // Gate: a business that hasn't finished setup can't reach the app — send it to
  // the setup page. Re-checks when the config loads (it arrives after login).
  const [, bump] = useState(configVersion());
  useEffect(() => subscribeBusinessConfig(bump), []);
  useEffect(() => {
    if (needsSetup() && location.pathname !== '/setup') navigate('/setup', { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, configVersion()]);

  return (
    <div className="flex min-h-screen text-base overflow-x-hidden bg-bone">
      <Sidebar />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-h-screen lg:ml-[270px] transition-all duration-300 min-w-0">
        <TopBar />

        {/* On a phone the bottom padding clears BOTH the 64px bottom nav and
            the quick-action FAB that floats above it (its top edge sits ~124px
            up) — so the last card's buttons are never underneath the FAB once
            the page is scrolled to the end. */}
        <main className="lg:mt-2 flex-1 bg-bone m-2 pb-32 lg:pb-2">
          {Content}
        </main>
      </div>

      {/* ONE floating button. The WhatsApp support bubble that used to stack
          under this is now the last item of its menu — two floats in one
          corner covered card actions on every phone. */}
      <QuickActionFAB />

      {/* Mobile Bottom Navigation */}
      <MobileBottomNav onLogout={logoutUser} />
    </div>
  );
};

export default BaseLayout;
